import _asyncToGenerator from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useRouter } from 'next/router';
import React from 'react';
import useSWR from 'swr';
import { toTime, toNowTime } from '@peloton/time';
import { updateContractAgreements } from '@engage/api-v2';
import { useLogout, LogoutEvent } from '@webtv/auth';
import { UsersFetchers } from '@webtv/data-fetch';
import { engageApi } from '@webtv/data-fetch/singletons';
import { PELOTON_PLATFORM } from '@webtv/env';
export var RequiredActions;

(function (RequiredActions) {
  RequiredActions["accept"] = "acceptance";
  RequiredActions["acknowledge"] = "acknowledge";
  RequiredActions["acknowledgeAndAccept"] = "acknowledge_and_acceptance";
  RequiredActions["none"] = "none";
})(RequiredActions || (RequiredActions = {}));

export var ContractUpdateType;

(function (ContractUpdateType) {
  ContractUpdateType["policy"] = "updatedPolicies";
  ContractUpdateType["terms"] = "updatedTerms";
  ContractUpdateType["termsAndPolicies"] = "updatedTermsAndPolicies";
})(ContractUpdateType || (ContractUpdateType = {}));

var ContractTakeoverBlocklist = ['/welcome', '/error', '/reset-password', '/terms', '/choose-username', '/create-account', '/free-trial', '/login', '/subscription'];
export var shouldSkipTakeoverForPath = function shouldSkipTakeoverForPath(router) {
  return ContractTakeoverBlocklist.find(function (path) {
    return router.pathname.startsWith(path);
  }) !== undefined;
};
export var usePendingContracts = function usePendingContracts() {
  var router = useRouter();
  var logout = useLogout(engageApi, LogoutEvent.DeclineTerms);

  var _useSWR = useSWR.apply(void 0, _toConsumableArray(UsersFetchers.GetMe({
    pelotonPlatform: PELOTON_PLATFORM
  }))),
      user = _useSWR.data,
      mutate = _useSWR.mutate,
      error = _useSWR.error;

  var contracts = user === null || user === void 0 ? void 0 : user.contractAgreements;
  var hasLoaded = !!user || !!error;

  var _React$useMemo = React.useMemo(function () {
    var derivedAction = RequiredActions.acknowledgeAndAccept;

    if (!(contracts !== null && contracts !== void 0 && contracts.length)) {
      return {
        requiredAction: derivedAction,
        pendingContracts: []
      };
    }

    var acknowledge = contracts.filter(function (contract) {
      return contract.requiredMemberAction === RequiredActions.acknowledge;
    });
    var accept = contracts.filter(function (contract) {
      return contract.requiredMemberAction === RequiredActions.accept;
    });
    var acknowledgeAndAccept = contracts.filter(function (contract) {
      return contract.requiredMemberAction === RequiredActions.acknowledgeAndAccept;
    });
    var filteredContracts = contracts.filter(function (contract) {
      return contract.requiredMemberAction !== 'none';
    });
    var hasPolicies = !!filteredContracts.filter(function (contract) {
      var _contract$contractTyp;

      return (_contract$contractTyp = contract.contractType) === null || _contract$contractTyp === void 0 ? void 0 : _contract$contractTyp.includes('policy');
    }).length;
    var hasTerms = !!filteredContracts.filter(function (contract) {
      var _contract$contractTyp2;

      return (_contract$contractTyp2 = contract.contractType) === null || _contract$contractTyp2 === void 0 ? void 0 : _contract$contractTyp2.includes('terms');
    }).length;
    var derivedUpdateType = ContractUpdateType.policy;

    if (hasPolicies && !hasTerms) {
      derivedUpdateType = ContractUpdateType.policy;
    } else if (hasPolicies && hasTerms) {
      derivedUpdateType = ContractUpdateType.termsAndPolicies;
    } else if (hasTerms && !hasPolicies) {
      derivedUpdateType = ContractUpdateType.terms;
    }

    if (!!acknowledgeAndAccept.length) {
      derivedAction = RequiredActions.acknowledgeAndAccept;
    } else if (!!accept.length && !!acknowledge.length) {
      derivedAction = RequiredActions.acknowledgeAndAccept;
    } else if (!!accept.length) {
      derivedAction = RequiredActions.accept;
    } else if (!!acknowledge.length) {
      derivedAction = RequiredActions.acknowledge;
    }

    return {
      handleContinue: function handleContinue() {
        var _user$id;

        return toHandleContinueClick((_user$id = user === null || user === void 0 ? void 0 : user.id) !== null && _user$id !== void 0 ? _user$id : '', filteredContracts, derivedAction, mutate);
      },
      requiredAction: derivedAction,
      pendingContracts: toFormattedContracts(filteredContracts, router),
      updatedContractTypes: derivedUpdateType
    };
  }, [contracts, mutate, router, user === null || user === void 0 ? void 0 : user.id]),
      updatedContractTypes = _React$useMemo.updatedContractTypes,
      requiredAction = _React$useMemo.requiredAction,
      pendingContracts = _React$useMemo.pendingContracts,
      handleContinue = _React$useMemo.handleContinue;

  return {
    updatedContractTypes: updatedContractTypes,
    hasLoaded: hasLoaded,
    requiredAction: requiredAction,
    pendingContracts: pendingContracts,
    handleContinue: handleContinue,
    handleLogout: logout
  };
};
export var toFormattedContracts = function toFormattedContracts(contracts, router) {
  return contracts.map(function (contract) {
    var _contract$contractCre;

    return {
      displayName: contract.contractDisplayName,
      onDocSelected: function onDocSelected() {
        return router.push({
          pathname: "/terms/".concat(contract.contractType)
        });
      },
      createdAt: toTime((_contract$contractCre = contract.contractCreatedAt) !== null && _contract$contractCre !== void 0 ? _contract$contractCre : 0)
    };
  });
};

var toHandleContinueClick = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(memberId, contracts, derivedAction, updateUser) {
    var currentTime, contractAgreements;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            currentTime = toNowTime().unix();
            contractAgreements = contracts.map(function (_ref2) {
              var contractId = _ref2.contractId;
              return {
                contractId: contractId,
                agreedAt: currentTime
              };
            });
            _context.prev = 2;
            _context.next = 5;
            return updateContractAgreements(engageApi, memberId, {
              contractAgreements: contractAgreements,
              modalDisplayed: derivedAction
            });

          case 5:
            updateUser();
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            console.error(_context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8]]);
  }));

  return function toHandleContinueClick(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();